import { useTheme } from '../../contexts/ThemeContext';

import '../../sassStyles/dynamic-menu-items/radio-menu-item.scss';

export default function RadioMenuItem(props) {
    const { theme } = useTheme();
    return (
        <div className={`${theme}-radio-container`}>
            <p>{props.label}</p>
            <div className='radio-options'>
                {
                    props.options.map(option => {
                        return (
                            <div key={option.id}>
                                <input type='radio' value={option.value} id={option.id} name={props.name} onChange={props.onChange} checked={option.checked} />
                                <label htmlFor={option.id} className='radio-button-label'>{option.labelText}</label>
                            </div>)
                    })
                }
            </div>
        </div>
    );
}
